<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.33732 0.208144C1.29585 -0.386985 0 0.365023 0 1.56454V8.33244C0 9.53195 1.29585 10.284 2.33732 9.68884L8.12362 6.38238V8.33244C8.12362 9.53195 9.41947 10.284 10.4609 9.68884L16.3829 6.30489C17.4324 5.70516 17.4324 4.19182 16.3829 3.59209L10.4609 0.208144C9.41947 -0.386985 8.12362 0.365023 8.12362 1.56454V3.5146L2.33732 0.208144Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgPlayerForward',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>